/* ==================================================================
   By Sophi v2 — shared interactive behaviors
   Loaded by all v2 sections. Handles wishlist sync + grid quick-add.
   ================================================================== */

(function () {
  'use strict';

  // ============ Wishlist (localStorage["bs_wishlist"]) ============
  const WISHLIST_KEY = 'bs_wishlist';

  const readWishlist = () => {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]'); }
    catch { return []; }
  };
  const writeWishlist = (arr) => {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(arr));
  };
  const toggleWishlist = (handle) => {
    const list = readWishlist();
    const idx = list.indexOf(handle);
    if (idx === -1) list.push(handle);
    else list.splice(idx, 1);
    writeWishlist(list);
    return idx === -1; // true = added, false = removed
  };

  // Sync heart UI for all visible cards
  const syncAllHearts = () => {
    const wl = readWishlist();
    document.querySelectorAll('.bs-v2-card__heart, .bs-v2-heart').forEach((btn) => {
      const handle = btn.dataset.productHandle;
      if (!handle) return;
      btn.classList.toggle('is-saved', wl.includes(handle));
    });
    // Update wishlist count badge if present in header
    const countEls = document.querySelectorAll('[data-bs-wishlist-count]');
    countEls.forEach((el) => {
      el.textContent = wl.length;
      el.style.display = wl.length > 0 ? '' : 'none';
    });
  };

  // Bind click handlers to heart buttons
  const bindHearts = (root) => {
    (root || document).querySelectorAll('.bs-v2-card__heart, .bs-v2-heart').forEach((btn) => {
      if (btn.dataset.bsBound === '1') return;
      btn.dataset.bsBound = '1';
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const handle = btn.dataset.productHandle;
        if (!handle) return;
        toggleWishlist(handle);
        syncAllHearts();
      });
    });
  };

  // ============ Quick-add from grid ============
  const openCartDrawer = () => {
    // Try multiple cart drawer open patterns (theme variants)
    document.dispatchEvent(new CustomEvent('cart:open'));
    window.dispatchEvent(new CustomEvent('bs:cart:open'));
    // Symmetry/Pixel Union pattern: trigger js-drawer-open-cart button
    const opener = document.querySelector('.js-drawer-open-cart, [data-action="open-cart"]');
    if (opener) opener.click();
  };

  const bindQuickAdd = (root) => {
    (root || document).querySelectorAll('[data-bs-quick-add]').forEach((btn) => {
      if (btn.dataset.bsBound === '1') return;
      btn.dataset.bsBound = '1';
      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        const variantId = btn.dataset.variantId;
        if (!variantId || btn.disabled) return;
        btn.classList.add('is-loading');
        btn.disabled = true;
        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1 }),
          });
          if (!res.ok) throw new Error('Add to cart failed');
          // Refresh cart count
          try {
            const cart = await fetch('/cart.js').then((r) => r.json());
            document.querySelectorAll('[data-bs-cart-count]').forEach((el) => {
              el.textContent = cart.item_count;
            });
          } catch {}
          openCartDrawer();
        } catch (err) {
          console.warn('[bs-v2 quick-add]', err);
          btn.textContent = 'Try again';
          setTimeout(() => { btn.textContent = '+ Add to cart'; }, 2000);
        } finally {
          btn.classList.remove('is-loading');
          btn.disabled = false;
        }
      });
    });
  };

  // ============ Init ============
  const init = () => {
    syncAllHearts();
    bindHearts();
    bindQuickAdd();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Cross-tab sync: when another tab updates wishlist, refresh hearts here
  window.addEventListener('storage', (e) => {
    if (e.key === WISHLIST_KEY) syncAllHearts();
  });

  // Expose helpers for other v2 scripts (PDP heart, wishlist page)
  window.BSv2 = window.BSv2 || {};
  window.BSv2.wishlist = { read: readWishlist, write: writeWishlist, toggle: toggleWishlist, sync: syncAllHearts };
  window.BSv2.bindHearts = bindHearts;
  window.BSv2.bindQuickAdd = bindQuickAdd;
  window.BSv2.openCart = openCartDrawer;
})();
